import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import ToastItem from './ToastItem/ToastItem';

const Toast: React.FC = () => {
  const globalStore = useContext(GlobalStoreCtx);

  return (
    <>
      {Array.from(globalStore.toast.items).map(([key, item]) => (
        <ToastItem key={key} item={item} />
      ))}
    </>
  );
};

export default observer(Toast);
